import { getWorkbookDisplayMode } from '@/main/routing.utilities';
import { WORKBOOK_DISPLAY } from '@/workbook/workbook.constants';

export function isViewOnlyWorkbookMode(displayMode?: WORKBOOK_DISPLAY) {
  return displayMode === WORKBOOK_DISPLAY.VIEW || getWorkbookDisplayMode() === WORKBOOK_DISPLAY.VIEW;
}

export function isPresentationWorkbookMode(displayMode?: WORKBOOK_DISPLAY) {
  return displayMode === WORKBOOK_DISPLAY.PRESENT || getWorkbookDisplayMode() === WORKBOOK_DISPLAY.PRESENT;
}

export function isEditWorkbookMode(displayMode?: WORKBOOK_DISPLAY) {
  return displayMode === WORKBOOK_DISPLAY.EDIT || getWorkbookDisplayMode() === WORKBOOK_DISPLAY.EDIT;
}
